"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringFilter = void 0;
var tslib_1 = require("tslib");
var AdvancedFilter_1 = require("./AdvancedFilter");
var StringFilter = /** @class */ (function (_super) {
    tslib_1.__extends(StringFilter, _super);
    function StringFilter(fields) {
        var _this = _super.call(this) || this;
        if (typeof fields === 'object') {
            Object.assign(_this, fields);
        }
        return _this;
    }
    return StringFilter;
}(AdvancedFilter_1.AdvancedFilter));
exports.StringFilter = StringFilter;
//# sourceMappingURL=StringFilter.js.map